import { useMutation } from "react-query";
import type { Paywall } from "@/react/types";
import { paywallCheckoutApi } from "@circle-react/api/paywallCheckoutApi";
import type { ShowEndpointQueryParams } from "@circle-react/api/paywallCheckoutApi.types";
import type {
  PaywallHandlerError,
  PreviewError,
} from "@circle-react/contexts/Paywalls/usePaywallCheckout";
import { useIsCouponStrikethroughEnabled } from "@circle-react/hooks/useIsCouponStrikethroughEnabled";
import type { CheckoutPreviewContext } from "../../types/CheckoutProps";
import { usePreviewMutation } from "../usePreviewMutation";
import { fetchMockedData } from "./fetchMockedData";

// import type { ShowResponseEndpoint } from "@circle-react/api/paywallCheckoutApi.types";
// import type { GetPreviewParametersReturn } from "../../helpers";

interface UseCouponPreviewMutationProps {
  checkoutPreviewContext?: CheckoutPreviewContext;
  paywall: Paywall;
}

export const useCouponPreviewMutation = ({
  checkoutPreviewContext,
  paywall,
}: UseCouponPreviewMutationProps) => {
  const oldPreviewMutation = usePreviewMutation({
    checkoutPreviewContext,
    paywall,
  });

  const fetcher =
    checkoutPreviewContext && paywall
      ? fetchMockedData(paywall, checkoutPreviewContext)
      : (params: ShowEndpointQueryParams) => paywallCheckoutApi.show(params);

  const newPreviewMutation = useMutation<
    any, // TODO: Apply the correct data type once the FF is removed
    PreviewError | PaywallHandlerError,
    any //  TODO: Apply the correct data type once the FF is removed
  >(fetcher);

  const isCouponStrikethroughEnabled = useIsCouponStrikethroughEnabled();
  if (!isCouponStrikethroughEnabled) {
    return oldPreviewMutation;
  }

  return newPreviewMutation;
};
